import type {
  CustomFieldDefinition,
  IssueTypeOption,
  IssueViewIssueType,
  IssueViewIssueTypeField,
  IssueViewStage,
} from "#app/lib/data";

// Client-only: which tab the issue view is on. No server equivalent, so it
// stays here (the ownership test says a second app would not need it). The
// array is the canonical DEFAULT order the per-user drag order normalizes
// against (see useDetailViewTabOrder).
export const ISSUE_VIEW_TABS = ["summary", "forms", "activity", "media"] as const;
export type IssueViewTab = (typeof ISSUE_VIEW_TABS)[number];
/** Share-only viewers get no Forms tab, so a shared Project discloses no form filled against it. */
export const GUEST_ISSUE_VIEW_TABS: readonly IssueViewTab[] =
  ISSUE_VIEW_TABS.filter((tab) => tab !== "forms");

// The issue view's local names for the fragments it selects. Each is an alias
// over a codegen fragment type, so none can drift from the schema:
//
//   IssueTypeOption     ≡ IssueTypeOption_issueType
//   IssueViewStage      ≡ IssueViewStage
//   CustomFieldDef      ≡ CustomFieldDefinition
//   IssueTypeFieldDef   ≡ IssueViewIssueTypeField
//
// There is no `requiredFieldIds` here: it is not a column on IssueType, it is
// `fields[].required` filtered, so callers derive it where they use it.
export type { IssueTypeOption, IssueViewStage };
export type CustomFieldDef = CustomFieldDefinition;
export type IssueTypeFieldDef = IssueViewIssueTypeField;
export type IssueTypeWithFields = IssueViewIssueType;
